import { FileUp, ScanText, BellRing } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const HowItWorks = () => {
  const { t } = useLang();
  const steps = [
    { icon: FileUp, title: t.how.step1Title, desc: t.how.step1Desc },
    { icon: ScanText, title: t.how.step2Title, desc: t.how.step2Desc },
    { icon: BellRing, title: t.how.step3Title, desc: t.how.step3Desc },
  ];

  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="py-20 lg:py-28 border-t border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="font-mono-label text-stone-500">{t.how.eyebrow}</span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-900 leading-tight">
            {t.how.title}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`how-step-${i + 1}`}
                className="bg-white border border-stone-200 rounded-2xl p-8 hover:border-green-900 transition-colors group"
              >
                <div className="w-12 h-12 rounded-lg bg-stone-100 grid place-items-center text-stone-700 group-hover:bg-green-900 group-hover:text-stone-50 transition-colors">
                  <Icon size={22} />
                </div>
                <h3 className="font-display mt-5 text-xl text-stone-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-stone-600 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
